import Alert from '../primitives/Alert'

export interface ErrorViewProps {
  error: Error | null
}

export default function ErrorView({ error }: ErrorViewProps) {
  return (
    <Alert severity="error">
      Sorry, something went wrong. Let us know if this persists and we&apos;ll get on fixing it.
      <br />
      <br />
      Message to show developers: {error?.message}
      <br />
      <br />
      In the meantime, please try fully reloading the app
    </Alert>
  )
}
